import React from 'react';
import DragBox from '../../DragBox/Drag/dragBox.component.jsx';
import { useGlobalContext } from "../../../Context/global.context.jsx";
import PatientMedCheck from './patientMedCheck.component.jsx';

const MedCheck = () => {
  const { selectedTopButtons, setSelectedTopButtons } = useGlobalContext();

  return (
    <DragBox
      id="MEDCHECK"
      storageKey="MEDCHECK_POSITION"
      defaultPos={{ x: 320, y: 360 }}
      title="MedsCheck"
      width={700}
      onAdd={null}
      zIndex={2050}
      addNote="-"
      onClose={() => {
        const updatedButtons = (selectedTopButtons || []).filter(btn => btn !== 'medcheck');
        setSelectedTopButtons(updatedButtons);
      }}
    >
      <PatientMedCheck />
    </DragBox>
  );
};

export default MedCheck;
